module.exports = __webpack_public_path__ + "static/img/mufg.b232eea2.svg";